import React from 'react';
import {get} from 'lodash';

import Text from '/component/base/Text';
import {HealthProfileTestIds} from '/constant/TestIDs';

import {styles} from './HealthProfile.style';

interface WeightChange {
  data?: {
    weightChange?: {
      diffImperial?: any;
    };
  };
}

interface InchesLost {
  data?: {
    waist?: {
      diffImperial?: any;
    };
  };
}

function renderText(
  label: string,
  value: string | number,
  valueStyle: any,
  testID = 'text',
) {
  return (
    <Text isBold style={styles.textLabel} testID={testID}>
      {label}
      {value !== '--' && (
        <Text isBold style={valueStyle}>
          {value}
        </Text>
      )}
    </Text>
  );
}

export function weightChangeImperial(weightChange: WeightChange): any {
  const totalWeightChange = get(
    weightChange,
    'data.weightChange.imperial',
    '--',
  );

  if (totalWeightChange === '--') {
    return renderText(
      'Weight lost since starting: ',
      '-- lbs',
      null,
      HealthProfileTestIds.weightLossLabel,
    );
  }

  const weightLabel =
    totalWeightChange === 0
      ? 'Weight lost since starting: '
      : totalWeightChange > 0
      ? 'Weight gained since starting: '
      : 'Weight lost since starting: ';

  const weightLabelStyle =
    totalWeightChange === 0
      ? styles.gainedWeightLabel
      : totalWeightChange > 0
      ? styles.negativeLabel
      : styles.positiveLabel;

  const value =
    totalWeightChange === 0
      ? '0 lbs'
      : `${totalWeightChange > 0 ? '+ ' : '- '}${Math.abs(
          totalWeightChange,
        )} lbs`;

  return renderText(
    weightLabel,
    value,
    weightLabelStyle,
    HealthProfileTestIds.weightLossLabel,
  );
}

export function waistInchesLost(inchesLost: InchesLost): any {
  const totalInchesLost = get(inchesLost, 'data.waist.diffImperial', '--');

  if (totalInchesLost === '--') {
    return renderText(
      'Total Inches lost since starting: ',
      '-- in',
      null,
      HealthProfileTestIds.waistSizeLostLabel,
    );
  }

  const waistLabel =
    totalInchesLost === 0
      ? 'Total Inches lost since starting: '
      : totalInchesLost > 0
      ? 'Total Inches lost since starting: '
      : 'Total Inches gained since starting: ';

  const waistLabelStyle =
    totalInchesLost === 0
      ? styles.gainedWeightLabel
      : totalInchesLost > 0
      ? styles.positiveLabel
      : styles.negativeLabel;

  const value =
    totalInchesLost === 0
      ? '0 in'
      : `${totalInchesLost > 0 ? '- ' : '+ '}${Math.abs(totalInchesLost)} in`;

  return renderText(
    waistLabel,
    value,
    waistLabelStyle,
    HealthProfileTestIds.waistSizeLostLabel,
  );
}
